import { Grid } from "@mui/material";
import { Form, Formik } from "formik";
import React, { useState } from "react";
import * as yup from "yup";
import {
  BtnSMGroupStyle,
  DRxInputStyle,
  InputSMBoxStyle,
  warnColor,
} from "../../../Theme";
import { Typography } from "@mui/material";
import DRxInput from "../../../uikit/DRxInput";
import { Box } from "@mui/material";
import { YSButton } from "../../../uikit/YSButton";
import { createNewTemplate, editTemplate } from "../../../Apis/TemplateApis";
import YSSnackBar from "../../../uikit/YSSnackBar";

const AddNewTemplate = (props: any) => {
  const [stateData, setStateData] = useState<any>({
    message: "",
    open: false,
    variant: "",
  });
  const handleSubmitTemplateCreation = async (
    { templateName, diagnosisName, diagnosisCode }: any,
    resetForm: any
  ) => {
    try {
      const createBody = {
        templateName: templateName,
        diagnosisCode: diagnosisCode,
        diagnosisName: diagnosisName,
        doctorId: localStorage.getItem("doctorId"),
      };
      const editBody = {
        templateName: templateName,
        diagnosisCode: diagnosisCode,
        diagnosisName: diagnosisName,
        doctorId: localStorage.getItem("doctorId"),
        templateId: props?.rowData?.id,
      };
      const API = props.isEdit
        ? editTemplate(editBody)
        : createNewTemplate(createBody);
      const result: any = await API;
      if (result?.data?.digitalRxStatusCode === 200) {
        setStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.response[0]?.message,
            variant: "success",
            open: true,
          };
        });

        setTimeout(() => {
          props.handleHideAddNewTemplatePopup();
          props.fetchApi();
        }, 1000);
      } else {
        setStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
      }
    } catch (error) {
      setStateData((prevState: any) => {
        return {
          ...prevState,
          message: "Try again after some time!",
          variant: "error",
          open: true,
        };
      });
    }
  };
  return (
    <>
      <Formik
        initialValues={{
          templateName: props?.isEdit ? props?.rowData?.templateName : "" ?? "",
          diagnosisCode: props?.isEdit
            ? props?.rowData?.diagnosisCode
            : "" ?? "",
          diagnosisName: props?.isEdit
            ? props?.rowData?.diagnosisName
            : "" ?? "",
        }}
        validationSchema={yup.object().shape({
          templateName: yup.string().required("Template name is required"),
          diagnosisCode: yup.string().nullable(),
          diagnosisName: yup.string().nullable(),
        })}
        enableReinitialize
        onSubmit={(values, { resetForm }) => {
          handleSubmitTemplateCreation(values, resetForm);
        }}
      >
        {(registerProps) => (
          <Form onSubmit={registerProps.handleSubmit}>
            <Grid
              container
              item
              xs={12}
              spacing={0}
              alignItems="top"
              justifyContent="space-between"
              columnSpacing={2}
            >
              <Grid item xs={12} md={12}>
                <InputSMBoxStyle>
                  <Typography
                    component="label"
                    variant="body2"
                    htmlFor="templateName"
                  >
                    Template Name
                    <Typography
                      component="span"
                      color={warnColor}
                      variant="body1"
                    >
                      *
                    </Typography>
                  </Typography>{" "}
                  <Box>
                    <DRxInputStyle>
                      <DRxInput
                        id="templateName"
                        placeholder="Enter template name"
                        name="templateName"
                        type="text"
                        className=""
                        disabled={false}
                        value={registerProps.values.templateName}
                        onChange={registerProps.handleChange}
                        onBlur={registerProps.handleBlur}
                        error={
                          registerProps.touched.templateName &&
                          Boolean(registerProps.errors.templateName)
                        }
                      />
                    </DRxInputStyle>
                  </Box>
                </InputSMBoxStyle>
              </Grid>
              <Grid item xs={12} md={12}>
                <InputSMBoxStyle>
                  <Typography
                    component="label"
                    variant="body2"
                    htmlFor="templateName"
                  >
                    Diagnosis Name
                  </Typography>{" "}
                  <Box>
                    <DRxInputStyle>
                      <DRxInput
                        id="diagnosisName"
                        placeholder="Enter diagnosis name"
                        name="diagnosisName"
                        type="text"
                        className=""
                        disabled={false}
                        value={registerProps.values.diagnosisName}
                        onChange={registerProps.handleChange}
                        onBlur={registerProps.handleBlur}
                      />
                    </DRxInputStyle>
                  </Box>
                </InputSMBoxStyle>
              </Grid>
              <Grid item xs={12} md={12}>
                <InputSMBoxStyle>
                  <Typography component="label" variant="body2" htmlFor="DC">
                    Diagnosis Code
                  </Typography>{" "}
                  <Box>
                    <DRxInputStyle>
                      <DRxInput
                        id="DC"
                        placeholder="Enter diagnosis code"
                        name="diagnosisCode"
                        type="text"
                        className=""
                        disabled={false}
                        value={registerProps.values.diagnosisCode}
                        onChange={registerProps.handleChange}
                        onBlur={registerProps.handleBlur}
                      />
                    </DRxInputStyle>
                  </Box>
                </InputSMBoxStyle>
              </Grid>

              <Grid item xs={12} md={12} marginTop={5}>
                <BtnSMGroupStyle>
                  <YSButton
                    size="large"
                    className=""
                    color="secondary"
                    dataTestId="submitBtn"
                    variant="outlined"
                    disabled={false}
                    type="reset"
                    children={"Reset"}
                    onClick={() => {
                      registerProps.resetForm({
                        values: {
                          templateName: "",
                          diagnosisCode: "",
                          diagnosisName: "",
                        },
                      });
                    }}
                  />
                  <YSButton
                    size="large"
                    className=""
                    color="primary"
                    dataTestId="submitBtn"
                    variant="contained"
                    disabled={false}
                    type="submit"
                    children={"Submit"}
                    onClick={null}
                  />
                </BtnSMGroupStyle>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
      <YSSnackBar
        message={stateData.message}
        variant={stateData.variant}
        open={stateData.open}
        handleClose={() => {
          setStateData((prevState: any) => {
            return { ...prevState, open: false };
          });
        }}
      />
    </>
  );
};

export default AddNewTemplate;
